import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { CollaboratorEditPanel } from '~/components/routes/hr/planning/collaborators/collaborator-edit-panel'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/planning/$tab/$collaboratorId')({
  staticData: {
    permission: ['read', 'hr-planning'],
  },
  component: RouteComponent,
  params: {
    parse: z.object({ tab: z.string(), collaboratorId: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function RouteComponent() {
  const { collaboratorId } = Route.useParams()

  return <CollaboratorEditPanel collaboratorId={collaboratorId} />
}
